import React, { useContext, useState } from "react";
import { CSVLink } from "react-csv";
import amplitude from "amplitude-js";
import Tooltip from "@mui/material/Tooltip";
import { Progress } from "@material-tailwind/react";

import lateSubmissionLogo from "../../../images/ic_warning_triangle.svg";
import ReEvaluateButton from "../../ReEvaluateButton";
import axios from "axios";
import appContext from "../../../context/appContext";

function ResultsTabBody({
  quiz_grace_time,
  quiz_title,
  created_timestamp,
  quizType,
  quiz_duration,
  csvReportForMiniMock,
  quiz_total_marks,
  quizData,
  getTimeString,
  handlerPerformance,
  get_list_of_attempted_students,
  handleSeeMoreClick,
  userType,
  handleRawResponseClick,
}) {
  const search = window.location.search;
  const params = new URLSearchParams(search);
  var id = params.get("id");

  // State for selected checkboxes, select all, and reviewed ids
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isBulkReviewing, setIsBulkReviewing] = useState(false);
  const [reviewedIds, setReviewedIds] = useState(new Set());
  const state = useContext(appContext);

  // Handle individual checkbox
  const handleChangeInCheckBox = (event, quiz_response_id) => {
    if (event.target.checked) {
      setSelectedIds((prev) => [...prev, quiz_response_id]);
    } else {
      setSelectedIds((prev) => prev.filter((id) => id !== quiz_response_id));
      setSelectAll(false);
    }
  };

  // Handle select all checkbox
  const handleSelectAll = (event) => {
    const checked = event.target.checked;
    setSelectAll(checked);
    if (checked) {
      const allIds = quizData.map((quiz) => quiz.quiz_response_id);
      setSelectedIds(allIds);
    } else {
      setSelectedIds([]);
    }
  };

  const handleReviewDoneInBulk = async () => {
    if (selectedIds.length === 0) return;
    setIsBulkReviewing(true);
    var token = "Bearer " + localStorage.getItem("access_token");
    try {
      await axios.request({
        method: "POST",
        url: process.env.REACT_APP_REST_API_BASE_URL + "/update_quiz_review_status",
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          authorization: token,
        },
        data: JSON.stringify({
          quiz_secret_key: id,
          quiz_response_id_csv: selectedIds.join(","),
        }),
      });
      // Mark these ids as reviewed in this session
      setReviewedIds((prev) => new Set([...prev, ...selectedIds]));
    } catch (e) {
      // Optionally handle error
    } finally {
      setIsBulkReviewing(false);
      setSelectedIds([]);
      setSelectAll(false);
      state.setShowBulkSuccess(true);
    }
  };

  return (
    <div>
      <div className=" flex sm:mr-[10px] sm:ml-[10px] md:mr-[120px] md:ml-[110px] mt-[16px]">
        <div className="student-info md:w-[60%] sm:mb-[10%] md:mb-0">
          <label className="teepee-label mr-[10px]">Task Name:</label>
          <label className="teepee-label">{quiz_title}</label>
        </div>
      </div>
      <div className=" flex sm:mr-[10px] sm:ml-[10px] md:mr-[120px] md:ml-[110px]">
        <div className="quiz-info-light md:items-center w-[60%]">
          {created_timestamp}
          <div className="ml-2">
            {quiz_duration !== 0 && <>&#8226; {(quiz_duration + quiz_grace_time) / 60 + " min "}</>}
            &#8226;
            {quizType === 1 ? " formative quiz" : quizType === 2 ? " mini-mock" : " exam style"}
          </div>
        </div>
        <div className="teepee-label justify-end w-[40%] ">
          {/* {selectedIds.length > 0 && ( */}
          <button
            className={`flex items-center gap-2 px-4 py-2 mx-2 text-white font-medium text-sm rounded-md ${
              isBulkReviewing || selectedIds.length < 1 ? "bg-gray-300" : "bg-[#43A047] hover:bg-[#2f994a]"
            } transition`}
            onClick={handleReviewDoneInBulk}
            disabled={isBulkReviewing || selectedIds.length < 1}
          >
            <span className="flex items-center justify-center bg-white rounded-full w-5 h-5">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="14"
                width="14"
                viewBox="0 0 24 24"
                fill={`${isBulkReviewing || selectedIds.length < 1 ? "#E0E0E0" : "#34A853"}`}
              >
                <path d="M0 0h24v24H0z" fill="none" />
                <path d="M9 16.17l-3.88-3.88L4 13.41 9 18.41 20 7.41 18.59 6 9 15.59z" />
              </svg>
            </span>
            Bulk Review & Share
          </button>
          {/* )} */}
          <CSVLink
            className="border-[1px] p-2 text-[14px] text-gray border-[#8E8888] rounded-[10px]"
            style={{ color: "#8E8888", textDecoration: "none" }}
            onClick={() => {
              amplitude.getInstance().logEvent("Download CSV (mini-mock)");
            }}
            {...csvReportForMiniMock}
          >
            Download CSV
          </CSVLink>
        </div>
      </div>
      <div className="sm:pl-[10px] sm:pr-[10px] md:pr-0 md:pl-[60px] mt-[20px] flex view-quiz-table sm:overflow-scroll md:overflow-hidden md:ml-[55px]">
        {quizData.length > 0 ? (
          <table id="studenTable" className="w-[93%]">
            <tr className="tr">
              <td id="checkbox" className="align-middle">
                <input type="checkbox" checked={selectAll} onChange={handleSelectAll} disabled={isBulkReviewing} className="align-middle" />
              </td>
              <th className="md:w-[70px] align-middle">Sr#</th>
              <th className="sm:text-center md:text-left sm:pr-[10px] sm:pl-[10px] md:pr-0 md:pl-0 align-middle ">Student Name</th>
              <th
                className="sm:pr-[20px] md:pr-0 align-middle"
                style={{
                  textAlign: "center",
                  display: quiz_duration === 0 && "none",
                }}
              >
                Time taken (min)
              </th>
              <th className="sm:pr-[20px] md:pr-0 align-middle" style={{ textAlign: "center" }}>
                Date
              </th>
              <th className="xs:pr-[10px] xs:pl-[10px] sm:pr-0 md:pl-0 align-middle" style={{ textAlign: "center" }}>
                Performance
              </th>
              <th className="sm:pr-[10px] sm:pl-[10px] md:pr-0 md:pl-0 align-middle" style={{ textAlign: "center" }}>
                Marks ({quiz_total_marks})
              </th>
              <th className="sm:pr-[10px] sm:pl-[10px] md:pr-0 md:pl-0 align-middle" style={{ textAlign: "center" }}>
                Review Status
              </th>
            </tr>
            {quizData.map((quiz, key) => {
              const checked = selectedIds.includes(quiz.quiz_response_id);
              const isReviewed = quiz.review_status || reviewedIds.has(quiz.quiz_response_id);
              return (
                <tr className="tr" key={key}>
                  <td id="checkbox" className="align-middle">
                    <input
                      type="checkbox"
                      checked={checked}
                      onChange={(e) => handleChangeInCheckBox(e, quiz.quiz_response_id)}
                      disabled={isBulkReviewing}
                      className="align-middle"
                    />
                  </td>
                  <td>{key + 1 + "."}</td>
                  <td className="sm:pr-[10px] sm:pl-[10px] md:pr-0 md:pl-0">{quiz.student_name}</td>
                  <td
                    className="sm:pr-[40px] sm:pl-[20px] md:pr-0 md:pl-0"
                    style={{
                      textAlign: "center",
                      display: quiz_duration === 0 && "none",
                    }}
                  >
                    {parseInt(quiz.quiz_attempt_duration / 60)}
                  </td>
                  <td className="sm:pr-[40px] sm:pl-[20px] md:pr-0 md:pl-0" style={{ textAlign: "center" }}>
                    <div
                      className="inline-flex"
                      style={{
                        marginTop: quizType === 2 && quiz.quiz_attempt_duration > quiz_duration + quiz_grace_time ? "10px" : "0px",
                      }}
                    >
                      {/* if quiz type is mini-mock and quiz attempt duration is greater then quiz_duration then displaying late submission warning icon */}
                      {quiz.quiz_attempt_duration > quiz_duration + quiz_grace_time && (
                        <Tooltip title={"Late Submission: " + getTimeString(quiz_duration + quiz_grace_time - quiz.quiz_attempt_duration)}>
                          <img alt="" src={lateSubmissionLogo}></img>
                        </Tooltip>
                      )}
                      {quiz.submitted_timestamp}
                    </div>
                  </td>
                  <td style={{ textAlign: "center" }}>
                    <div className="performace-label">
                      {handlerPerformance(quiz)}
                      {quiz.partially_evaluated === 1 && (
                        <ReEvaluateButton quiz_secret_key={id} quiz={quiz} get_list_of_attempted_students={get_list_of_attempted_students} />
                      )}
                    </div>
                    <div className="flex w-full flex-col gap-4">
                      <Progress
                        value={quiz.performance}
                        color={quiz.performance >= 80 ? "green" : quiz.performance >= 70 ? "light-green" : quiz.performance >= 50 ? "yellow" : "red"}
                      />
                    </div>
                  </td>
                  <td style={{ textAlign: "center" }}>{((quiz_total_marks * quiz.overall_score) / 100).toFixed(2)}</td>

                  <td className="text-center">
                    <div className="flex flex-col justify-self-center my-2">
                      {isReviewed ? (
                        <div class="completed-badge">
                          <span class="icon-circle">
                            <svg xmlns="http://www.w3.org/2000/svg" height="12" viewBox="0 0 24 24" width="12" fill="white">
                              <path d="M0 0h24v24H0z" fill="none" />
                              <path d="M9 16.17l-3.88-3.88L4 13.41 9 18.41 20 7.41 18.59 6 9 15.59z" />
                            </svg>
                          </span>
                          Completed
                        </div>
                      ) : (
                        <div class="pending-badge">
                          {/* <span class="icon-circle-warning"> */}
                          <svg xmlns="http://www.w3.org/2000/svg" height="12" viewBox="0 0 24 24" width="12" fill="white">
                            <path d="M1 21h22L12 2 1 21z" fill="#B45309" />
                            <path d="M12 16h-1v-1h2v1h-1zm0-3h-1v-4h2v4h-1z" fill="white" />
                          </svg>
                          {/* </span> */}
                          Pending Review
                        </div>
                      )}
                      <div className="font-medium text-[0.5rem] ">
                        {isReviewed ? "Feedback shared with student." : "Check and approve before sharing with student."}
                      </div>
                      <button id="button" name={quiz.student_name} value={key} onClick={handleSeeMoreClick} className="text-[#6750a4]">
                        {isReviewed ? "[VIEW]" : "[Start Review]"}
                      </button>
                    </div>
                  </td>
                  <td
                    style={{
                      display: userType === "2" ? "" : "none",
                    }}
                  >
                    <button
                      id="button1"
                      name={quiz.student_name}
                      value={key}
                      onClick={() => {
                        handleRawResponseClick(quiz.quiz_response_id);
                      }}
                      className="my-quizzes-card-buttons my-quizzes-card-view-quiz-button"
                    >
                      Raw Response
                    </button>
                  </td>
                </tr>
              );
            })}
          </table>
        ) : (
          <div className="text-center w-[100%] mr-[20%]">No task Results Yet.</div>
        )}
      </div>
    </div>
  );
}

export default ResultsTabBody;
